import { FC, useContext } from 'react';
import { getLocaleDate } from 'utils/time';
import { ReviewPageContext } from '.';
import { Container } from './components';

const NoAnswer: FC = () => {
  const { interview } = useContext(ReviewPageContext);

  return (
    <Container>
      <p>
        Vous aviez proposé un entretien à la date du{' '}
        {interview?.date && getLocaleDate(interview.date)}, mais{' '}
        {interview?.mentorship?.mentee?.firstName} n'a pas répondu à temps.
      </p>
    </Container>
  );
};

export default NoAnswer;
